import React, { Component } from 'react';
import {
    Container, Grid, Segment, Header, Table, Label, Button, Image, List, Icon
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
    getClaimOptions,
    updateOutpatientClaim,
    getUnsubmittedClaimAttachment,
    updateUnsubmittedOutpatientClaim,
    getEclaimOptionsPageAction,
    getClaimOptionsRequest
} from '../../actions';
import FormsUpdateClaimOutpatient from '../../component/forms/claim/outpatient/update';

class ClaimUpdateOutPage extends Component {
    // componentDidMount() {
    //     this.props.getClaimOptions(this.props.user.accessToken);
    // }
    render() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        // const selectedOutpatientClaim = _.find(this.props.outpatientClaims, (claim) => claim.transactionNo === claimTransactionNo);
        const selectedOutpatientClaim = this.props.viewedClaims[claimTransactionNo];
        console.log("check selectedOutpatientClaim", selectedOutpatientClaim)
        return (
            <Container fluid>
                <Segment attached="top">
                    <Header>Update Claim - {claimTransactionNo}</Header>
                </Segment>
                <Link to={`/app/claimrecords/out/${claimTransactionNo}/${selectedOutpatientClaim.status}`}>
                    <Button attached>
                        <Icon name="user cancel" />
                        Cancel Update - Go back to view this claim
                    </Button>
                </Link>
                <Segment attached>
                    <Grid>
                        <Grid.Column>
                            <FormsUpdateClaimOutpatient
                                updateOutpatientClaim={this.props.updateOutpatientClaim}
                                claimTransactionNo = {claimTransactionNo}
                                updateUnsubmittedOutpatientClaim={this.props.updateUnsubmittedOutpatientClaim}
                                user={this.props.user}
                                claimAttachment={this.props.claimAttachment}
                                claimOptions={(this.props.claimOptions) ? this.props.claimOptions.outpatientClaimOptions : {}}
                                inpatientClaimOptions={(this.props.claimOptions) ? this.props.claimOptions.inpatientClaimOptions : {}}
                                currentClaimData={selectedOutpatientClaim}
                                configBenefit={this.props.configBenefit}
                                appLaunchConfig={this.props.appLaunchConfig}
                                claims={this.props.claims}
                                claimFilterOptions={this.props.claimFilterOptions}
                                getEclaimOptionsPageAction={this.props.getEclaimOptionsPageAction}
                                filteredByCompany={this.props.claimOptions.companyId}
                                filteredByClaimantId={this.props.claimOptions.claimantId}
                                filteredByVisitDate={this.props.claimOptions.visitDate}
                                getClaimOptionsRequest={this.props.getClaimOptionsRequest}
                                isLoaded={this.props.isLoaded}

                            />
                        </Grid.Column>
                    </Grid>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user.user,
        claimOptions: state.claimOptions,
        outpatientClaims: state.claims.outpatientClaims,
        viewedClaims: state.claims.viewed,
        configBenefit: state.user.configBenefit,
        claimAttachment: state.claims.claimImage,
        appLaunchConfig: state.appLaunchConfig,
        claims: state.claims.data,
        claimFilterOptions: state.claims.filterOptions,
        isLoaded:state.claims.isLoaded

    };
}

export default connect(mapStateToProps, {getClaimOptions, updateOutpatientClaim, updateUnsubmittedOutpatientClaim, getUnsubmittedClaimAttachment, getEclaimOptionsPageAction, getClaimOptionsRequest})(ClaimUpdateOutPage);
